import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=060464c8&lang=scss&scoped=true"
script.__scopeId = "data-v-060464c8"

export default script